import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import toast, { Toaster } from "react-hot-toast";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ProductList = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const [showImagesModal, setShowImagesModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  let is_alert = false;

  const userId = localStorage.getItem("user_id");
  const loggedinuserType = localStorage.getItem("user_type");
  const [hoveredRow, setHoveredRow] = useState(null);

  const handleMouseEnter = (id) => {
    setHoveredRow(id);
    localStorage.removeItem("user_id");
  };

  const handleMouseLeave = () => {
    setHoveredRow(null);
  };

  useEffect(() => {
    if (location.state !== null) {
      if (is_alert === false) {
        toast.success(location.state);
      }
      is_alert = true;
    }
    window.history.replaceState({}, location.state);
  }, []);

  const [rooms, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [monthFilter, setMonthFilter] = useState("");
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userType = user?.user_type;

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  const BuyerLeadData = () => {
    const token = localStorage.getItem("Token");

    // search/monthFilter were tracked in state (and search's box even
    // triggered a refetch on change) but neither was ever appended to the
    // request — this always fetched the same unfiltered page.
    const params = new URLSearchParams();
    params.append("page", page);
    if (search) params.append("search", search);
    if (monthFilter) params.append("month", monthFilter);
    const apiUrl = `${process.env.REACT_APP_URL}/admin/supplier_products?${params.toString()}`;

    axios
      .get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // `.pages` never existed on the response (it's
        // `.pagination.totalPages`), so this always left totalPage
        // undefined and pagination silently showed nothing.
        setTotalPage(res?.data?.data?.pagination?.totalPages || 1);
        setData(res?.data?.data.products);
      })
      .catch((err) => {
        if (err.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        } else {
          console.error(err);
        }
      });
  };

  const HandleActiveDeactive = (id, status) => {
    let statusText = "";
    let Color = "";
    if (status === true) {
      statusText = "Deactive";
      Color = "#DC3741";
    } else {
      statusText = "Active";
      Color = "#1b55e2";
    }

    Swal.fire({
      title: `Do you want to ${statusText} this Record?`,
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: Color,
      confirmButtonText: statusText,
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .post(
            `${process.env.REACT_APP_URL}/admin/roles/change-status`,
            {
              id: id,
              status: status ? false : true,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("Token")}`,
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              toast.success(res.data.message);
              BuyerLeadData();
            }
          })
          .catch((err) => {

            const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
            const STATUS = [401, 403];
            if (
              STATUS.includes(err.response.status) ||
              MSG.includes(err.response.data.msg)
            ) {
              localStorage.clear();
              Navigate("/admin/login");
            } else {
              toast.error(err?.response?.data?.msg);
            }
          });
      }
    });
  };

  const HandleDelete = (e) => {
    Swal.fire({
      title: "Do you want to Delete this Record?",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#DC3741",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .delete(`${process.env.REACT_APP_URL}/admin/roles/delete?id=${e}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          })
          .then((res) => {
            if (res.status === 200) {
              Swal.fire({
                title: "Deleted Sucessfully.",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
              });
              BuyerLeadData();
            }
          })
          .catch((err) => {

            const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
            const STATUS = [401, 403];
            if (
              STATUS.includes(err.response.status) ||
              MSG.includes(err.response.data.msg)
            ) {
              localStorage.clear();
              Navigate("/admin/login");
            } else {
              toast.error(err?.response?.data?.msg);
            }
          });
      }
    });
  };

  const exportToExcel = () => {
    if (rooms.length === 0) {
      alert("No data to export.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(rooms);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(fileData, "supplier-product.xlsx");
  };

  useEffect(() => {
    BuyerLeadData();
  }, [page, search, monthFilter]);

  const IMG_BASE = process.env.REACT_APP_IMAGE_URL;
  const TINTS = [
    { bg: "var(--color-info-bg)", color: "var(--color-info-text)" },
    { bg: "var(--color-success-bg)", color: "var(--color-success-text)" },
    { bg: "var(--color-violet-bg)", color: "var(--color-violet-text)" },
    { bg: "var(--color-warning-bg)", color: "var(--color-warning-text)" },
  ];
  const tintCat = (s = "") => TINTS[(String(s).length) % TINTS.length];
  const fmt = (d) =>
    d ? new Date(d).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false }) : "—";
  const strip = (html = "") => (html || "").replace(/<[^>]+>/g, "");
  const parseImages = (item) => {
    let images = [];
    try { images = JSON.parse(item?.product_image || "[]"); }
    catch (e) { images = item?.product_image ? [item.product_image] : []; }
    return (images || []).map((img) => `${IMG_BASE}${img}`);
  };

  const [dense, setDense] = useState(false);
  const [sortDir, setSortDir] = useState("");
  const [isMobileView, setIsMobileView] = useState(typeof window !== "undefined" && window.innerWidth < 768);
  useEffect(() => {
    const h = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  let displayData = [...(rooms || [])];
  if (sortDir) {
    displayData.sort((a, b) => {
      const av = (a?.title || "").toLowerCase();
      const bv = (b?.title || "").toLowerCase();
      if (av < bv) return sortDir === "asc" ? -1 : 1;
      if (av > bv) return sortDir === "asc" ? 1 : -1;
      return 0;
    });
  }

  const PicIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
  );
  const tileBase = { display: "inline-flex", width: 26, height: 26, borderRadius: 7, alignItems: "center", justifyContent: "center", border: 0, padding: 0, cursor: "pointer" };
  const ImageStack = ({ item }) => {
    const imgs = parseImages(item);
    const openAll = () => { setSelectedImage(imgs); setShowImagesModal(true); };
    if (!imgs.length) {
      const t = TINTS[0];
      return <span style={{ ...tileBase, background: t.bg, color: t.color, cursor: "default" }}><PicIcon /></span>;
    }
    const shown = imgs.slice(0, 3);
    const extra = imgs.length - shown.length;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        {shown.map((_, i) => {
          const t = TINTS[i % TINTS.length];
          return (
            <button type="button" key={i} title="View images" style={{ ...tileBase, background: t.bg, color: t.color }} onClick={openAll}>
              <PicIcon />
            </button>
          );
        })}
        {extra > 0 && (
          <button type="button" title="View images" style={{ fontSize: 11, fontWeight: 700, color: "var(--color-text-tertiary)", background: "transparent", border: 0, cursor: "pointer", padding: 0 }} onClick={openAll}>
            +{extra}
          </button>
        )}
      </div>
    );
  };

  const ActiveToggle = ({ item }) => (
    <button type="button" className={`al-toggle ${item.is_active ? "is-on" : ""}`}
      title={item.is_active ? "Deactivate" : "Activate"}
      onClick={() => HandleActiveDeactive(item.id, item.is_active)}>
      <span className="al-toggle__knob" />
    </button>
  );

  const viewState = (item) => ({
    state: {
      id: item?.user_id, name: item?.title, size: item?.size,
      print_coverage: item?.print_coverage, paper_gsm: item?.paper_gsm,
      no_of_ply: item?.no_of_ply, material_color: item?.material_color,
      lamination: item?.lamination, burst_factor: item?.burst_factor,
      created_at: item?.created_at, description: item?.description,
      product_image: item?.product_image, quantity: item?.quantity,
    },
  });

  const RowActions = ({ item }) => (
    <div className="al-actions">
      <button type="button" className="al-act" title="View"
        onClick={() => Navigate("/admin/supplier-product-show", viewState(item))}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
      </button>
      <button type="button" className="al-act al-act--danger" title="Delete"
        onClick={() => HandleDelete(item?.id)}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
      </button>
    </div>
  );

  const GRID = { gridTemplateColumns: "88px 1.4fr .8fr 1.6fr 1.1fr .9fr 100px" };

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Supplier Products</h1>
          <p className="al-sub">Products listed by suppliers on the marketplace.</p>
        </div>
        <div className="al-head__actions">
          {userType === "admin" && (
            <button type="button" className="al-btn al-btn--primary" onClick={exportToExcel}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Export
            </button>
          )}
        </div>
      </div>

      <div className="al-card">
        <div className="al-toolbar">
          <div className="al-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-text-tertiary)" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
            <input type="search" placeholder="Search products by title, supplier…"
              onKeyDown={(e) => e.key === "Enter" && BuyerLeadData()}
              onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className="al-select">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            <select value={monthFilter} onChange={(e) => { setMonthFilter(e.target.value); setPage(1); }}>
              <option value="">Select Month</option>
              <option value="1">Last 1 Month</option>
              <option value="3">Last 3 Months</option>
              <option value="6">Last 6 Months</option>
            </select>
          </div>
          <button type="button" className="al-tool" style={{ marginLeft: "auto" }} onClick={() => setDense((d) => !d)} title="Toggle density">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            {dense ? "Comfortable" : "Density"}
          </button>
        </div>

        {!isMobileView ? (
          <div className="al-tablewrap">
            <div style={{ minWidth: 980, "--al-row-pad": dense ? "8px" : "13px" }}>
              <div className="al-thead" style={GRID}>
                <span className="al-th">Product Image</span>
                <span className="al-th al-th--sort" onClick={() => setSortDir((d) => (d === "asc" ? "desc" : d === "desc" ? "" : "asc"))}>
                  Name
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: sortDir ? 1 : 0.45, transform: sortDir === "desc" ? "rotate(180deg)" : "none" }}><polyline points="18 15 12 9 6 15"/></svg>
                </span>
                <span className="al-th">Size</span>
                <span className="al-th">Description</span>
                <span className="al-th">Date &amp; Time</span>
                <span className="al-th">Approved</span>
                <span className="al-th al-th--right">Action</span>
              </div>

              {displayData && displayData.length > 0 ? (
                displayData.map((item, index) => (
                  <div className="al-row" style={GRID} key={index}>
                    <ImageStack item={item} />
                    <span className="al-name">{item?.title}</span>
                    <span className="al-mono al-muted al-ellipsis" title={item?.size}>{item?.size || "—"}</span>
                    <span className="al-muted al-ellipsis" title={strip(item?.description)}>{strip(item?.description) || "—"}</span>
                    <span className="al-mono al-muted">{fmt(item?.created_at)}</span>
                    <span><ActiveToggle item={item} /></span>
                    <RowActions item={item} />
                  </div>
                ))
              ) : (
                <div className="al-empty">
                  <div className="al-empty__icon">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                  </div>
                  <p className="al-empty__title">No Products Found</p>
                  <p className="al-empty__text">Supplier products will appear here.</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="al-mobile">
            {displayData && displayData.length > 0 ? (
              displayData.map((item, index) => {
                const t = tintCat(item?.title);
                return (
                  <div className="al-mcard" key={index}>
                    <div className="al-mcard__top">
                      <ImageStack item={item} />
                      <div className="al-name" style={{ flex: 1 }}>{item?.title}</div>
                      <ActiveToggle item={item} />
                    </div>
                    <div className="al-mrow"><span className="al-muted">Size</span><span className="al-mono">{item?.size || "—"}</span></div>
                    <div className="al-mrow"><span className="al-muted">Date</span><span className="al-mono al-muted">{fmt(item?.created_at)}</span></div>
                    <div className="al-mactions"><RowActions item={item} /></div>
                  </div>
                );
              })
            ) : (
              <div className="al-empty"><p className="al-empty__title">No Products Found</p></div>
            )}
          </div>
        )}

        <div className="al-foot">
          <span className="al-foot__info">Showing <strong>{displayData?.length || 0}</strong> products</span>
          {rooms?.length !== 0 && (
            <ReactPaginate
              previousLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>}
              nextLabel={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>}
              breakLabel={"..."}
              pageCount={totalpage}
              marginPagesDisplayed={2}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-end m-0"}
              pageClassName={"page-item"} pageLinkClassName={"page-link"}
              previousClassName={"page-item"} previousLinkClassName={"page-link"}
              nextClassName={"page-item"} nextLinkClassName={"page-link"}
              breakClassName={"page-item"} breakLinkClassName={"page-link"}
              activeClassName={"active"} />
          )}
        </div>
      </div>

      {showImagesModal && (
        <div className="al-modal" onClick={() => setShowImagesModal(false)}>
          <div className="al-modal__scrim" />
          <div className="al-modal__box" onClick={(e) => e.stopPropagation()} style={{ width: "min(520px,92vw)" }}>
            <div className="al-modal__head">
              <h3 className="al-modal__title">Product Images</h3>
              <button type="button" className="al-act" onClick={() => setShowImagesModal(false)}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div style={{ padding: 20 }}>
              {selectedImage && selectedImage.length > 0 ? (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
                  {selectedImage.map((img, index) => (
                    <img key={index} src={img} alt={`Product ${index + 1}`}
                      style={{ width: "100%", height: 110, objectFit: "cover", borderRadius: 10, cursor: "pointer", border: "1px solid var(--color-border)" }}
                      onClick={() => window.open(img, "_blank")} />
                  ))}
                </div>
              ) : (
                <p className="al-muted" style={{ textAlign: "center" }}>No image available</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductList;
